import BookItem from "../common/bookItem";
import VisibleSwitchTranslate from "./visible_switch_translate";
export default class VisibleSwitchTranslateChild extends BookItem {
    constructor(el, target) {
        super(el, target);
        this.el = el;
        this.connectNumber = this.el.connectNumber;

        this.ansChildGroup = [];
        this.ansGroup = [];
        this.add_mouse_event();
    }

    init() {
        this.target.gotoAndStop(0);
        this.ansChildGroup = this.itemControl.getItemsByClassConnect("translatechild", this);
    }

    trigger() {
        const self = this;
        let canSeeAllAns = true;

        if (self.isOpen == false) {
            self.target.gotoAndStop(1);
            console.log("變看得見");
        }
        else if (self.isOpen == true) {
            self.target.gotoAndStop(0);
            console.log("變看不見");
        }

        self.isOpen = !self.isOpen;
        console.log("isOpen:", self.isOpen);

        self.ansChildGroup.forEach(element => {
            if (element.isOpen == false) {
                //有答案看不到
                canSeeAllAns = false;
            }
        });

        self.mainGroup.forEach(element => {
            if (canSeeAllAns) {
                element.isOpen = true;
            }
            else {
                element.isOpen = false;
            }
        });
    }

    add_mouse_event() {
        this.target.mouseChildren = false;
        this.target.removeAllEventListeners();
        this.target.addEventListener("click", () => {
            this.trigger();
        });
    }
}